import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Reserver from "@/pages/Reserver";
import PaiementSucces from "@/pages/PaiementSucces";
import PaiementAnnule from "@/pages/PaiementAnnule";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import FormuleDetail from "@/pages/FormuleDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminBlog from "@/pages/AdminBlog";
import AdminAbonnes from "@/pages/AdminAbonnes";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/formules/:slug" element={<FormuleDetail />} />
                        <Route path="/reserver" element={<Reserver />} />
                        <Route path="/paiement/succes" element={<PaiementSucces />} />
                        <Route path="/paiement/annule" element={<PaiementAnnule />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/blog" element={<AdminBlog />} />
                        <Route path="/admin/abonnes" element={<AdminAbonnes />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    theme="dark"
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "rgba(10,10,10,0.95)",
                            border: "1px solid rgba(245,183,84,0.3)",
                            color: "#fff",
                        },
                    }}
                />
            </div>
        </HelmetProvider>
    );
}

export default App;
